import React, { useEffect, useState } from "react";
import { Card, CardContent } from "@mui/material";
import Tab from '../Tab';
import { MdHistory } from "react-icons/md";
import { useSelector } from "react-redux";
import { getIssueStatusHistory, createIssueStatus } from "../../api/issueApi";
import LoadingSpinner from "../LoadingSpinner";
import Grid from "../Grid";
import { IssueStatusCellStyle } from "../renderer/StyleRenderer";

const IssueStatusManagement = ({ issueId, issueCode, statusOptions, close }) => {
    const [history, setHistory] = useState([]);
    const [currentStatus, setCurrentStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const fetchHistory = async () => {
        if (!issueId) return;
        try {
            setIsLoading(true);
            const data = await getIssueStatusHistory(issueId);
            const mapped = data.map((item) => ({
                ...item,
                fliStatus: statusOptions?.find(
                    s => Number(s.value) === item.tfsFleetStatus
                )?.text || item.tfsFleetStatus,
                fliStatusId: item.tfsFleetStatus,
                tfsDateFormatted: item.tfsDate
                    ? new Date(item.tfsDate).toLocaleString()
                    : "N/A",
            }));
            setHistory(mapped);
            if (mapped && mapped.length > 0) {
                setCurrentStatus(mapped.reduce((a, b) => new Date(a.tfsDate) > new Date(b.tfsDate) ? a : b));
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchHistory();
    }, [issueId]);

    const IssueStatusHeader = () => (
        <div className="ui segment" style={{ marginBottom: "10px" }}>
            <div className="ui three column grid">
                <div className="column">
                    <strong>Issue:</strong> {issueCode}
                </div>
                <div className="column">
                    <strong>Current Status:</strong>{" "}
                    {currentStatus ? (
                        <IssueStatusCellStyle value={currentStatus.fliStatus} />
                    ) : "N/A"}
                </div>
                <div className="column">
                    <strong>Last Updated:</strong>{" "}
                    {currentStatus?.tfsDateFormatted || "N/A"}
                </div>
            </div>
        </div>
    );

    const historyGridConfig = [
        {
            headerName: "#",
            valueGetter: (params) => params.node.rowIndex + 1,
            width: 60,
            minWidth: 60,
            maxWidth: 60,
        },
        {
            headerName: "Status",
            field: "fliStatus",
            width: 180,
            cellRenderer: IssueStatusCellStyle,
        },
        {
            headerName: "Updated By",
            field: "createdBy",
            width: 150,
        },
        {
            headerName: "Date",
            field: "tfsDateFormatted",
            width: 200,
            sort: "desc",
            comparator: (a, b) => new Date(a) - new Date(b),
        },
    ];

    return (
        <Card>
            <CardContent style={{ height: "80vh", minWidth: "65vw", overflow: "scroll" }}>
                <div className="ui top attached tabular menu">
                    <Tab
                        Icon={MdHistory}
                        active={true}
                        label="Status History"
                        authenticated={false}
                    />
                </div>
                <div className="ui bottom attached active tab segment">
                    <IssueStatusHeader />
                    {isLoading ? (
                        <LoadingSpinner />
                    ) : (
                        <Grid
                            heading=" "
                            isLoading={isLoading}
                            autoHeight={true}
                            searchable={true}
                            content={history}
                            config={historyGridConfig}
                            multiRowSelection={false}
                            pagination={true}
                            pageSize={10}
                        />
                    )}
                </div>
            </CardContent>
        </Card>
    );
};

export default IssueStatusManagement;
